import dosiClin from "./dosi_clin.png";
import dosiPreclin from "./preclinica.jpg";
import modelComp from "./modelagem_comp.png";
import teamImg from "./time.png";
import securityImg from "./security.png";
import expensesImg from "./expenses.png";
import teamHome from "./team_home.png";

// Home services
const services = [
  {
    id: "dosi-clin",
    title: "ServiceDosiClinTitle",
    body: "ServiceDosiClinBody",
    img: dosiClin,
    shortDescription: "ServiceDosiClinShortDescription",
    longDescription: [
      "ServiceDosiClinLongDescription1",
      "ServiceDosiClinLongDescription2",
    ],
    detailedInfo: {
      serviceInfo: ["ClinDosiServiceInfo1", "ClinDosiServiceInfo2"],
      deliveryInfo: [
        "ClinDosiDeliveryInfo1",
        "ClinDosiDeliveryInfo2",
        "ClinDosiDeliveryInfo3",
      ],
      refundPolicy: ["ClinDosiRefundPolicy1", "ClinDosiRefundPolicy2"],
    },
    productDescription: "ServiceDosiClinProductDescription",
  },
  {
    id: "dosi-preclin",
    title: "ServiceDosiPreclinTitle",
    body: "ServiceDosiPreclinBody",
    img: dosiPreclin,
    shortDescription: "ServiceDosiPreclinShortDescription",
    longDescription: ["ServiceDosiPreclinLongDescription"],
    detailedInfo: {
      serviceInfo: [
        "PreClinDosiServiceInfo1",
        "PreClinDosiServiceInfo2",
        "PreClinDosiServiceInfo3",
      ],
      deliveryInfo: [
        "PreClinDosiDeliveryInfo1",
        "PreClinDosiDeliveryInfo2",
        "PreClinDosiDeliveryInfo3",
      ],
      refundPolicy: ["PreClinDosiRefundPolicy1", "PreClinDosiRefundPolicy2"],
    },
    productDescription: "ServiceDosiPreclinProductDescription",
  },
  {
    id: "model-comp",
    title: "ServiceModelCompTitle",
    body: "ServiceModelCompBody",
    img: modelComp,
    shortDescription: "ServiceModelCompShortDescription",
    longDescription: [
      "ServiceModelCompLongDescription1",
      "ServiceModelCompLongDescription2",
      "ServiceModelCompLongDescription3",
      "ServiceModelCompLongDescription4",
    ],
    detailedInfo: {
      serviceInfo: [
        "ModelCompServiceInfo1",
        "ModelCompServiceInfo2",
        "ModelCompServiceInfo3",
      ],
      deliveryInfo: [
        "ModelCompDeliveryInfo1",
        "ModelCompDeliveryInfo2",
        "ModelCompDeliveryInfo3",
      ],
      refundPolicy: ["ModelCompRefundPolicy1", "ModelCompRefundPolicy2"],
    },
    productDescription: "ServiceModelProductDescription",
  },
];
// Company pros
const companyPros = [
  {
    title: "CompanyProSecurityTitle",
    text: "CompanyProSecurityText",
    img: securityImg,
  },
  {
    title: "CompanyProExpenseTitle",
    text: "CompanyProExpenseText",
    img: expensesImg,
  },
  {
    title: "CompanyProTimeTitle",
    text: "CompanyProTimeText",
    img: teamImg,
  },
];

export { services, companyPros, teamImg, teamHome };
